import React from "react";
import { useStoreManagementStore } from "@/store/storeManagementStore";
import { Store } from "@/models/storeModel";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { GetIndustryIcon } from "@/utils/industryUtils";

interface StoreSelectorProps {
  stores?: Store[];
  value: string;
  onValueChange: (storeId: string) => void;
  disabled?: boolean;
  selectedStoreId?: string;
  className?: string;
  isSelectable?: boolean;
  isInChat?: boolean;
  noOfEmployees?: number;
}

export const StoreSelector: React.FC<StoreSelectorProps> = ({
  stores,
  value,
  onValueChange,
  disabled,
  className,
  isSelectable = true,
  isInChat,
  noOfEmployees,
}) => {
  return (
    <Select
      onValueChange={onValueChange}
      value={value}
      disabled={disabled || !isSelectable}
    >
      <SelectTrigger className={className}>
        <SelectValue placeholder="Select a store" />
      </SelectTrigger>
      <SelectContent>
        {stores?.map((store) => (
          <SelectItem key={store.id} value={store.id}>
            <div className="flex items-center gap-2">
              {GetIndustryIcon(store.industry_type)}
              {store.name}
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
